import { Theme as MuiTheme, ThemeOptions as MuiThemeOptions } from '@mui/material/styles';

export interface TenantLogos {
  main: string;
  light?: string;
  dark?: string;
  icon?: string;
  [key: string]: string | undefined;
}

export interface TenantMedia {
  logos: TenantLogos;
  authBackground?: string;
  authCircleInside?: string;
  authCircleOutside?: string;
}

export type CustomThemeOptions = MuiThemeOptions;
export type CustomTheme = MuiTheme;

declare module '@mui/material/styles' {
  interface Theme {
    gradients: {
      primary: string;
      secondary: string;
    };
    media: TenantMedia;
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    gradients?: {
      primary?: string;
      secondary?: string;
    };
    media?: TenantMedia;
  }
}

// Ensure styled-components knows about the theme
import 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme extends MuiTheme {
    gradients: {
      primary: string;
      secondary: string;
    };
    media: TenantMedia;
  }
}
